import React, { useState, useEffect } from 'react';
import { FiX, FiClock, FiGlobe } from 'react-icons/fi';
import { loginHistoryAPI } from '../../services/api';
import { formatDateTime } from '../../utils/helpers';
import { LocationBadgeWithIP } from '../common/LocationBadge';

const LoginHistoryDialog = ({ user, onClose }) => {
  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLoginHistory = async () => {
      try {
        setLoading(true);
        const data = await loginHistoryAPI.getByUser(user.id, { limit: 50 });
        setLoginHistory(data);
      } catch (err) {
        setError('Error al cargar el historial de accesos');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLoginHistory();
  }, [user.id]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Historial de Accesos
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              {user.name} (@{user.username})
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <FiX className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
          ) : error ? (
            <div className="text-center py-12">
              <p className="text-red-600">{error}</p>
            </div>
          ) : loginHistory.length === 0 ? (
            <div className="text-center py-12">
              <FiClock className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No hay historial de accesos</p>
            </div>
          ) : (
            <div className="space-y-3">
              {loginHistory.map((login, index) => (
                <div
                  key={login.id}
                  className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1 space-y-2">
                      <div className="flex items-center space-x-2">
                        <FiClock className="h-4 w-4 text-gray-400" />
                        <span className="text-sm font-medium text-gray-900">
                          {formatDateTime(new Date(login.login_at))}
                        </span>
                        {index === 0 && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                            Más reciente
                          </span>
                        )}
                      </div>

                      {/* Ubicación geográfica con IP */}
                      <LocationBadgeWithIP loginRecord={login} />

                      {/* User agent */}
                      {login.user_agent && (
                        <div className="text-xs text-gray-500 font-mono bg-gray-100 p-2 rounded mt-2">
                          {login.user_agent}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-gray-200 bg-gray-50">
          <p className="text-sm text-gray-600">
            Total de accesos: <span className="font-semibold">{loginHistory.length}</span>
          </p>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginHistoryDialog;
